window.digitalData = window.digitalData || [];

const anonymousUser = {
    loginGUID: '',
    powerCustomerKey: '',
    userAccountId: ''
}

const getFullPageName = () => {
    let pageTitle = document.title.replace(/(\s\|\s)|SRP\s(Power|My\sAccount)/g, '')
    let pageName = pageTitle !== '' ? `|${pageTitle.toLowerCase()}` : window.location.pathname.toLowerCase().replace(/\//g,'|')
    let fullPageName = `srp|myaccount${pageName}`
    return fullPageName
}

export const pageLoadEvent = (customerKey, userAccountId, userId) => {
    let doNotTrack = window.doNotTrack === "1" || navigator.doNotTrack === "1"

    let fullPageName = getFullPageName()

    let pageLoadEvent = {
        event: 'page load',
        page: {
            URLfull: window.location.href,
            URL: window.location.origin + window.location.pathname,
            pageName: fullPageName,
            pageType: 'myaccount',
            businessUnit: 'power',
            heirarchy_level1: '',
            heirarchy_level2: '',
            heirarchy_level3: '',
            heirarchy_level4: '',
            heirarchy_level5: '',
            language: 'en',
            siteDomain: window.location.hostname,
            application: 'myaccount-power'
        },
        user: doNotTrack ? anonymousUser : {
            loginGUID: userId,
            powerCustomerKey: !customerKey ? '' : customerKey.toString(),
            userAccountId: userAccountId
        }
    }

    // Note: We can't legally "reset" the digitalData array without paying for a license ($6k/year).
    // And because the extension being used overrides the push method,
    // we can't just reassign the variable back to an empty array.
    window.digitalData.push(pageLoadEvent)
}

export const viewChangedEvent = (customerKey, userAccountId, userId) => {
    let doNotTrack = window.doNotTrack === "1" || navigator.doNotTrack === "1"

    let fullPageName = getFullPageName()

    let viewChangedEvent = {
        event: 'view change',
        page: {
            URLfull: window.location.href,
            URL: window.location.origin + window.location.pathname,
            pageName: fullPageName,
            language: 'en'
        },
        user: doNotTrack ? anonymousUser : {
            loginGUID: userId,
            powerCustomerKey: !customerKey ? '' : customerKey.toString(),
            userAccountId: userAccountId
        }
    }

    window.digitalData.push(viewChangedEvent)
}

export const errorEvent = (error) => {
    window.digitalData.push({ event: 'error track', error })
}

export const formErrorEvent = (formName) => {
    errorEvent({
        errorMessage: 'There was an error while trying to submit form',
        errorType: 'form error',
        formName: formName
    })
}

export const formStartEvent = (name, formStep) => {
    let formTrackEvent = {
        event: 'form track',
        form: { name, formStep: 'Form Start', firstStep: formStep }
    }
    window.digitalData.push(formTrackEvent)
}

export const autoFormStartEvent = (name, formStep) => {
    let formTrackEvent = {
        event: 'form track',
        form: { name, formStep: 'Form Start', firstStep: formStep + " (auto-generated)" }
    }
    window.digitalData.push(formTrackEvent)
}

export const formEvent = (name, formStep) => {
    let formTrackEvent = {
        event: 'form track',
        form: { name, formStep }
    }
    window.digitalData.push(formTrackEvent)
}

export const formCompleteEvent = (name, meta) => {
    let formTrackEvent = {
        event: 'form track',
        form: { name, formStep: 'Form Complete', meta: JSON.stringify(meta) }
    }
    window.digitalData.push(formTrackEvent)
}
